import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { id: "modal" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$root.$emit('clickOutside'))),
    onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.$root.$emit('enter')), ["enter"]))
  }, [
    _createVNode(_component_router_view),
    _hoisted_1
  ], 32))
}